import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import TestToBePerformWithCompanyName from "./LabServiceModel/TestToBePerformWithCompanyName"

export interface LabServicesGetParams {
  ImplementationID?: number
  LabAccountNumber: string
  VendorID: number
  IsDOT: boolean
  IsPoct: boolean
  AutoFilterValue?: string
  IsMarketPlace: boolean
  Link?: string
}

export default function TestToBePerformGetObservable(params: LabServicesGetParams): Observable<TestToBePerformWithCompanyName> {
  const requestBody: string = JSON.stringify(params)
  return ObservableFromFetch<TestToBePerformWithCompanyName>("order/GetTestToBePerformsWithCompanyName", requestBody)
}